var _templateObject = _taggedTemplateLiteralLoose(['\n  button {\n    display: flex;\n    :hover {\n      background-color: ', ';\n    }\n  }\n'], ['\n  button {\n    display: flex;\n    :hover {\n      background-color: ', ';\n    }\n  }\n']),
  _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  min-width: 160px;\n  min-height: 82px;\n  background-color: ', ' !important;\n  border: 0;\n  :hover {\n    text-decoration: none;\n  }\n'], ['\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  min-width: 160px;\n  min-height: 82px;\n  background-color: ', ' !important;\n  border: 0;\n  :hover {\n    text-decoration: none;\n  }\n']),
  _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-weight: 500;\n  font-family: ', ';\n  color: #ffffff;\n  align-self: center;\n  font-size: 11px;\n  text-transform: uppercase;\n  cursor: pointer;\n  text-decoration: none;\n'], ['\n  font-weight: 500;\n  font-family: ', ';\n  color: #ffffff;\n  align-self: center;\n  font-size: 11px;\n  text-transform: uppercase;\n  cursor: pointer;\n  text-decoration: none;\n']),
  _templateObject4 = _taggedTemplateLiteralLoose(['\n  svg path {\n    stroke: #FFFFFF;\n    stroke-width: 1.5;\n  }\n'], ['\n  svg path {\n    stroke: #FFFFFF;\n    stroke-width: 1.5;\n  }\n']);
function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}
import React, { useState } from 'react';
import { Dropdown, DropdownToggle } from 'reactstrap';
import styled from 'styled-components';
import { lightBlue, darkerLtGrey } from '../../assets/colors';
import { Montserrat } from '../../assets/fonts';
import getPgaTld from '../../getPgaTld';
import { UserIcon } from '../Icons';
import { DropDown } from '../MemberDropdown/pieces';
export var StyledDropdown = styled(Dropdown)(_templateObject, darkerLtGrey);
var StyledDropdownToggle = styled(DropdownToggle)(_templateObject2, lightBlue);
var StyledText = styled.div(_templateObject3, Montserrat);
var MyAccountIcon = styled(UserIcon)(_templateObject4);
var pgaTld = getPgaTld();
var options = [{
  id: 1,
  to: 'https://account.' + pgaTld + '/signup',
  label: 'Create Account'
}, {
  id: 2,
  to: 'https://account.' + pgaTld + '/login?return_to=https://account.' + pgaTld,
  label: 'Login'
}];
export default (function () {
  var _useState = useState(false),
    dropdownOpen = _useState[0],
    setDropdownOpen = _useState[1];
  var toggle = function toggle() {
    return setDropdownOpen(function (prevState) {
      return !prevState;
    });
  };
  return React.createElement(StyledDropdown, {
    isOpen: dropdownOpen,
    toggle: toggle
  }, React.createElement(StyledDropdownToggle, null, React.createElement(MyAccountIcon, null), React.createElement(StyledText, null, 'My Account')), React.createElement(DropDown, {
    options: options,
    publicDropdown: true
  }));
});